import React, { useState, useEffect, useRef, useContext } from "react";
import { Card, Select, Spin, Tooltip } from "antd";
import ApexCharts from "apexcharts";
import useLearnerTrainings from "PlatForms/OrgLMS/Hooks/LearnerHooks/useTraining";
import api from "Common/Client/Interceptor";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import API from "Common/Client/endpoint";
const { Option } = Select;
const LearnerTrainingProgress = () => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const learnerUserId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");
  const { nameList } = useLearnerTrainings(learnerUserId, token);
  const [selectedTrainingId, setSelectedTrainingId] = useState(null);
  const [chart, setChart] = useState(null);
  const [loading, setLoading] = useState(false);
  const chartRef = useRef(null);
  // Fetch training data
  useEffect(() => {
    if (selectedTrainingId && chartRef.current) {
      const fetchTrainingData = async () => {
        try {
          setLoading(true);
          const response = await api.get(API.charts.getTrainingChart(selectedTrainingId));
          renderChart(response.data);
        } catch (error) {
          console.error("Error fetching training data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchTrainingData();
    }
  }, [selectedTrainingId, isBlocked]);
  const renderChart = (trainingData) => {
    const formatDate = (dateString) => new Date(dateString).toLocaleDateString();
    const dates = trainingData.progressPoints.map((p) => formatDate(p.dateSubmitted));
    const progress = trainingData.progressPoints.map((p) => p.progressPercent);
    const tooltipsData = trainingData.progressPoints.map((p) => ({
      date: formatDate(p.dateSubmitted),
      taskTitle: p.taskTitle,
      score: p.score,
    }));
    const options = {
      chart: { type: "line", height: 450, toolbar: { show: true } },
      stroke: { curve: "smooth", width: 3 },
      markers: { size: 6 },
      series: [{ name: "Progress %", data: progress }],
      xaxis: {
        categories: dates,
        title: { text: `Timeline (${formatDate(trainingData.startDate)} → ${formatDate(trainingData.endDate)})` },
      },
      yaxis: { min: 0, max: 100, title: { text: "Progress (%)" } },
      tooltip: {
        custom: ({ dataPointIndex }) => {
          const point = tooltipsData[dataPointIndex];
          return `
            <div style="padding:10px;">
              <strong>${point.taskTitle}</strong><br/>
              Date: ${point.date}<br/>
              Score: ${point.score}/5
            </div>
          `;
        },
      },
      title: {
        text: trainingData.trainingTitle + " - Progress Overview",
        align: "left",
        style: { fontSize: "14px" },
      },
      colors: ["#00B8D9"],
    };
    if (chart) {
      chart.updateOptions(options);
    } else {
      const newChart = new ApexCharts(chartRef.current, options);
      newChart.render();
      setChart(newChart);
    }
  };
  const handleTrainingChange = (value) => setSelectedTrainingId(value);
  const handleClearSelection = () => {
    setSelectedTrainingId(nameList.length > 0 ? nameList[0].id : null);
    if (chart) {
      chart.destroy();
      setChart(null);
    }
  };
  useEffect(() => {
    if (nameList.length > 0 && !selectedTrainingId) {
      setSelectedTrainingId(nameList[0].id);
    }
  }, [nameList]);
  return (
    <Card title="Learner Training Progress" style={{ opacity: isBlocked ? 0.6 : 1 }}>
      <Spin spinning={loading}>
        <Tooltip title={isBlocked ? "Complete your profile to unlock training progress" : ""}>
          <Select
            style={{ width: "50%" }}
            placeholder="Please select training"
            onChange={handleTrainingChange}
            value={selectedTrainingId}
            allowClear
            onClear={handleClearSelection}
            loading={loading}
            disabled={isBlocked} //  disable select
          >
            {nameList.map((training) => (
              <Option key={training.id} value={training.id}>
                {training.title}
              </Option>
            ))}
          </Select>
        </Tooltip>
        {selectedTrainingId && !isBlocked && (
          <>
            <br />
            <br />
            <Card>
              <div ref={chartRef} style={{ maxWidth: "900px", margin: "auto" }} />
            </Card>
          </>
        )}
      </Spin>
    </Card>
  );
};
export default LearnerTrainingProgress;

